import { defineEffect } from '../../../core/effect';

/**
 * **チェーンの終わり**（Issue #571）。残っている対象の照準の枠を全部消す（念のため。ふつうは `chain_solved` /
 * 無効のリンクの `chain_solving` で消えている）。**絵は持たない**。
 */
export default defineEffect({
  situation: 'chain_end',
  role: 'effect',
  label: 'チェーンの終わり（対象の枠を消す）',
  color: '#8a8aa0',
  duration: () => 1,
  clears: () => [{ mark: 'targetSight' }],
}, 'chain_end_effect.js');
